<template>
  <SlideIn
    :open="isOpen"
    heading="Search Results"
    :content-padding="false"
    @close="isOpen = false"
  >
    <template #content>
      <div class="search-input__wrapper container">
        <SearchInput />
      </div>
      <Search />
    </template>
  </SlideIn>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Search from "@/components/navigation/Search.vue";
import SearchInput from "@/components/SearchInput.vue";
import SlideIn from "@/components/SlideIn.vue";

export default {
  name: "SearchDesktop",
  components: {
    Search,
    SearchInput,
    SlideIn,
  },
  computed: {
    ...mapState("search", ["isSearchOpen"]),
    isOpen: {
      get() {
        return this.isSearchOpen;
      },
      set(val) {
        return this.setSearchOpen(val);
      },
    },
  },
  methods: {
    ...mapActions("search", ["setSearchOpen"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";

.search-input__wrapper {
  padding-top: 30px;
  margin-bottom: 20px;
}

:deep(.search-input) {
  @extend .input__element;
}
</style>
